import app from '~/app';

/**
 * @param {String} name
 * @returns {String}
 */
export function getParam(name) {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(name);
}

/**
 * Set / updates search query
 * @param {String} name
 * @param {String} value
 */
export function setParam(name, value) {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set(name, value);
  window.history.replaceState(null, null, `?${searchParams.toString()}`);
}

/**
 * Updates page param and searches for more products
 */
export function loadMore(callback) {
  const currPage = Number(getParam('p') ?? 1);
  const newPage = currPage + 1;
  setParam('p', newPage);

  callback();
}

/**
 * Everything about pagination and status
 * @param {Object} data
 */
export function handlePagination(data, paginationEl, context) {
  const loadMoreBtn = paginationEl.querySelector('[data-load-more]');
  const progressStatus = paginationEl.querySelector('[data-progress-translation]');
  const progressBar = paginationEl.querySelector('[data-progress]');

  const contextObj = {};

  switch (context) {
    case 'search':
      contextObj.loaded = 'searchPaginationLoaded';
      contextObj.statusString = 'searchStatus';
      break;

    case 'blog':
      contextObj.loaded = 'blogPaginationLoaded';
      contextObj.statusString = 'blogStatus';
      break;

    default:
      break;
  }

  const loaded = app.getState()[contextObj.loaded];
  const currProgress = (loaded / data.hits) * 100;

  const progressText = () => {
    const text = window.theme.strings[contextObj.statusString];
    const final = text
      .replace('{{ count }}', loaded)
      .replace('{{ max }}', data.hits);
    return final;
  };

  progressStatus.innerHTML = progressText();
  progressStatus.classList.remove('hidden');
  progressBar.style.width = `${currProgress}%`;

  if (loaded < data.hits) {
    loadMoreBtn.classList.remove('hidden');
  } else {
    loadMoreBtn.classList.add('hidden');
  }
}
